import toast from "react-hot-toast";
import clienteAxios from "../config/clienteAxios";

const getArticles = async () => {
  try {
    const response = await clienteAxios.get("/article");
    return response;
  } catch (error) {
    toast.error('Error al obtener los articulos');
  }
}

const changeVisibilityArticle = async (id, visibility) => {
  return await clienteAxios.put(`/article/${id}`, visibility)
}

const updateArticlesPositionsService = async (articles) => {
  return await clienteAxios.put(`/article/positions`, articles)
}

export { 
  getArticles,
  changeVisibilityArticle,
  updateArticlesPositionsService
}